@if(state == 'success'){
<h1>Congratulations!</h1>
<h3>Successfully created a new subscription... will redirect back to customer screen in {{countdown}} seconds</h3>
}
@else {
<h1>Subscription Cancelled!</h1>
<h3>Adjust as needed after redirect in {{countdown}} seconds...</h3>
}